import { render, staticRenderFns } from "./excecoesFuncUsuario.vue?vue&type=template&id=325f6655&scoped=true&"
import script from "./excecoesFuncUsuario.vue?vue&type=script&lang=js&"
export * from "./excecoesFuncUsuario.vue?vue&type=script&lang=js&"
import style0 from "./excecoesFuncUsuario.vue?vue&type=style&index=0&id=325f6655&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f6655",
  null
  
)

export default component.exports